import { createContext } from 'react'
import type {
  AuthResponse,
  AuthUser,
  LoginRequest,
  RegisterRequest,
  UpdateProfileRequest,
} from '~/services/auth/types'

export interface GuestUser {
  id: string
  displayName: string
  userIconUrl: null
  isGuest: true
}

export interface AuthContextValue {
  user: AuthUser | null
  guestUser: GuestUser | null
  isLoading: boolean
  isAuthenticated: boolean
  isGuest: boolean
  login: (request: LoginRequest) => Promise<void>
  register: (request: RegisterRequest) => Promise<AuthResponse>
  logout: () => Promise<void>
  updateProfile: (request: UpdateProfileRequest) => Promise<void>
  loginWithVRoidCallback: () => Promise<void>
  startGuestSession: (name: string) => void
  endGuestSession: () => void
  refreshUser: () => Promise<void>
  error: string | null
  clearError: () => void
}

const DEFAULT_VALUE: AuthContextValue = {
  user: null,
  guestUser: null,
  isLoading: true,
  isAuthenticated: false,
  isGuest: false,
  login: async () => {},
  register: async () => ({
    user: {
      id: '',
      email: '',
      emailVerified: false,
      pendingEmail: null,
      notificationEmail: null,
      notificationEmailVerified: false,
      displayName: '',
      userIconUrl: null,
      userCoverUrl: null,
    },
  }),
  logout: async () => {},
  updateProfile: async () => {},
  loginWithVRoidCallback: async () => {},
  startGuestSession: () => {},
  endGuestSession: () => {},
  refreshUser: async () => {},
  error: null,
  clearError: () => {},
}

export const AuthContext = createContext<AuthContextValue>(DEFAULT_VALUE)
